<template>
    <div :class="wrapperClass">
        <h3 :class="animationClass">{{personalizedMessages[counter]}}</h3>
    </div>
</template>
<script>


    export default {
        name: 'waiting-therapy',
        props: {
            username: {
                type: String,
                default: null,
            },
            interval:{
                type: Number,
                default: 5000,
            },
            wrapperClass:{
              type:String,
              default: ''
            },
            animationClass:{
                type:String,
                default:'blink'
            }
        },
        components: {},
        data() {
            return {
                counter: 0,
                messages: [
                    'Currently processing your file on our server.',
                    'Almost there, give it a second',
                    'So much data to process!',
                    'Nearly there..',
                    'Are we there yet?',
                    'Could have grabbed a coffee ;)'
                ]
            }
        },
        computed: {
            personalizedMessages() {
                if (this.username.length > 1 && typeof this.username === "string") {
                    return [
                        this.username + ", We are currently processing your file on our server.",
                        "Almost there, give it a second",
                        "So much data to process !",
                        "Nearly there..",
                        "Are we there yet..?",
                        "Could have grabbed a coffee in the  meanwhile "
                    ]
                }
                else {
                    return this.messages
                }
            }
        },
        methods: {},
        created() {
            var self = this
            setInterval(() => {
                var maxLength = self.personalizedMessages.length - 1
                if (self.counter < maxLength) {
                    self.counter++
                } else {
                    self.counter = 0
                }
            }, self.interval)
        }
    }
</script>
<style>
    .blink {
        animation: blinker 3s linear infinite;
    }

    @keyframes blinker {
        50% {
            opacity: 0.4;
        }
    }
</style>
